import React, { useState, useEffect, useCallback } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import axios from 'axios';

//React export function used to display the consignee address block
export default function ConsigneeAddress(props) {
    const { addresses, consigneeName, contactDetails, termType } = props;

    //Setting the states 
    const [values, setValues] = useState([]);
    const [deliveryvalues, setDeliveryValues] = useState([]);
    const [checked, setChecked] = useState([false, false]);
    const [hide, setHide] = useState(false);
    const [consigneeAddressID, setConsigneeAddressID] = useState(0);
    const [deliveryAddressID, setDeliveryAddressID] = useState(0);
    const [defaultValue, setDefaultValue] = useState([]);
    const [defaultDeliveryAddressValue, setDefaultDeliveryAddressValue] = useState('');
    const [defaultConsigneeAddress, setDefaultConsigneeAddress] = useState(null);
    const [hasLockedConsignee, setHasLockedConsignee] = useState(false);

    useEffect(() => {
        function getDefaultConsigneeAddress() {
            //Check if import
            if (termType === 'EXW' || termType === 'FCA' || termType === 'FOB') {
                //Check if default address has already been set, avoiding another call to the server
                if (!defaultConsigneeAddress) {
                    axios
                        .get(`${process.env.REACT_APP_API_ENDPOINT}/api/address/Get`)
                        .then((res) => {
                            setConsigneeAddressID(res.data[0].id);
                            setDefaultConsigneeAddress(res.data[0]);
                            setHasLockedConsignee(true)
                        })
                        .catch((e) => {
                            console.error(`Failed to get default consignee address for user with error: ${e}`);
                        });
                } else {
                    //Select has come back to import, default has already been set so set flag and selected id.
                    setHasLockedConsignee(true)
                    setConsigneeAddressID(defaultConsigneeAddress.id);
                }
            } else {
                //Export, so false and render auto complete
                setHasLockedConsignee(false);
            }
        }

        getDefaultConsigneeAddress();
    }, [termType, defaultConsigneeAddress]);

    useEffect(() => {
        const getDefaultDeliveryAddress = () => {
            if (addresses !== null && addresses !== undefined) {
                var cne = {};
                var del = {};
                addresses.forEach((address) => {
                    if (address.addressUseCode === 'CNE') {
                        cne = address;
                    }
                    if (address.addressUseCode === 'DEL') {
                        del = address;
                    }
                });

                if (cne.addressID !== del.addressID) {
                    setDeliveryAddressID(del.addressID);
                    setDefaultDeliveryAddressValue(`${del.organisationName}, ${del.townCity}, ${del.countryCode}`);
                    setHide(true);
                    setChecked([true, true]);
                }
            }
        };
        getDefaultDeliveryAddress();
    }, [addresses]);

    useEffect(() => {
        const getDefaultConsignee = () => {
            if (consigneeName !== null && consigneeName !== undefined) {
                axios
                    .get(`${process.env.REACT_APP_API_ENDPOINT}/api/address/GetAddress`, { params: { searchField: consigneeName } })
                    .then((res) => {
                        setDefaultValue(res.data);
                    })
                    .catch((e) => {
                        console.log('error happened');
                    });
            }
        };

        getDefaultConsignee();
    }, [consigneeName])

    const handleConsigneeAddressID = useCallback((newValue) => {
        if (newValue !== null && newValue !== undefined) {
            setConsigneeAddressID(newValue.id);
            axios
                .get(`${process.env.REACT_APP_API_ENDPOINT}/api/address/GetFullAddressByID`, { params: { Id: newValue.id } })
                .then((res) => {
                    contactDetails({ addressId: res.data.id, contacts: res.data.contactDetails });
                })
                .catch((e) => {
                    console.log('Consignee Address by id was not obtained');
                });
        }
        else {
            contactDetails([]);
        }
    }, [contactDetails]);

    useEffect(() => {
        const setDefaultConsigneeAddressID = (newValue) => {
            if (newValue !== null && newValue !== undefined) {
                setConsigneeAddressID(newValue.id);
                handleConsigneeAddressID(newValue);
            }
        };

        setDefaultConsigneeAddressID(defaultValue[0]);
    }, [defaultValue, handleConsigneeAddressID]);

    const handleChange = (event) => {
        setHide(prev => !prev);
        setChecked([event.target.checked, event.target.checked]);
    };

    //On change handle the get address request
    const handleConsignee = ({ target }) => {
        if (target !== undefined) {
            setValues([]);
            const { value } = target;
            axios
                .get(`${process.env.REACT_APP_API_ENDPOINT}/api/address/GetAddress`, { params: { searchField: value } })
                .then((res) => {
                    setValues(res.data);
                })
                .catch((e) => {
                    console.log('error happened');
                });
        }
    };

    //On change handle the get address request
    const handleDeliveryAddress = ({ target }) => {
        if (target !== undefined) {
            setDeliveryValues([]);
            const { value } = target;
            axios
                .get(`${process.env.REACT_APP_API_ENDPOINT}/api/address/GetAddress`, { params: { searchField: value } })
                .then((res) => {
                    setDeliveryValues(res.data);
                })
                .catch((e) => {
                    console.log('error happened');
                });
        }
    };

    const handleDeliveryAddressID = (newValue) => {
        if (newValue !== null && newValue !== undefined) {
            setDeliveryAddressID(newValue.id);
        }
    };

    //Render the dropdowns onto the screen
    return (
        <>
            <GridContainer direction={'row'}>
                <GridItem xs={12}>
                    <input type="hidden" name="consigneeAddressID" id="consigneeAddressID" value={consigneeAddressID} />
                    <input type="hidden" name="deliveryAddressID" id="deliveryAddressID" value={deliveryAddressID} />

                    {hasLockedConsignee
                        ? <TextField
                            name="Consignee"
                            id="Consignee"
                            label="Consignee"
                            InputLabelProps={{ shrink: true, required: true }}
                            value={defaultConsigneeAddress.label}
                            type="text"
                            style={{ marginTop: '20px', width: '100%' }}
                            size="small"
                            disabled
                        />
                        : <Autocomplete
                            size="small"
                            disablePortal
                            id="Consignee"
                            options={values}
                            onInputChange={(event) => handleConsignee(event || {})}
                            onChange={(event, newValue) => {
                                handleConsigneeAddressID(newValue)
                            }}
                            sx={{ marginTop: 1, width: '100%' }}
                            renderInput={(params) => <TextField size="small" {...params} id="Consignee" name="Consignee" label="Consignee" required />}
                        />}

                    <FormControlLabel
                        label="Different Delivery Address"
                        sx={{ marginLeft: '2px' }}
                        control={<Checkbox checked={checked[0]} onChange={handleChange} name="cbDeliveryAddress" id="cbDeliveryAddress" />}
                    />

                    {hide && <Autocomplete
                        size="small"
                        disablePortal
                        id="DeliveryAddress"
                        options={deliveryvalues}
                        onInputChange={(event) => handleDeliveryAddress(event || {})}
                        onChange={(event, newValue) => {
                            handleDeliveryAddressID(newValue)
                        }}
                        defaultValue={defaultDeliveryAddressValue}
                        sx={{ marginTop: 1 }}
                        renderInput={(params) => <TextField size="small" {...params} id="DeliveryAddress" name="DeliveryAddress" label="Delivery Address" required />}
                    />}
                </GridItem>
            </GridContainer>
        </>
    );
}